export default __webpack_public_path__ + "static/0261-4e4662e19d6f50d8778cf31f2006d90a.png";